var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("GatewaySettings", { attrs: { "display-name": "Email" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }